import React, { useEffect, useState } from "react";
import { Jumbotron, Button, Row, Col, Container } from "reactstrap";
import { Tabs, Card, Table } from "antd";

import { CardContent } from "semantic-ui-react";
import { Link } from "react-router-dom";

import Navigation from "../components/Navigation";
import Footer from "../components/Footer";

import Iframe from "react-iframe";
import { UserContext } from "../index";
import { Firestore } from "../config/firebase";

export default function Home() {
  const { TabPane } = Tabs;

  const [data, setData] = useState([]);
  const [accelerator, setaccelerator] = useState([]);
  const [Crypto, setCrypto] = useState([]);
  const [Hackathon, setHackathon] = useState([]);
  const [Grants, setGrant] = useState([]);
  const [Bounty, setBounty] = useState([]);
  const [VentureFund, setVentureFund] = useState([]);

  useEffect(() => {
    async function fetchUpdates() {
      Firestore.collection("updates").orderBy("createdAt", "desc")
        .get()
        .then(function (querySnapshot) {
          let docs = [];
          querySnapshot.forEach(function (doc) {
            docs.push(doc.data());
            // doc.data() is never undefined for query doc snapshots

            setTimeout(() => {
              setData(docs);
            }, 1000);
          });
        });

      Firestore.collection("updates")
        .where("Type", "==", "Accelerator")
        .orderBy("createdAt", "desc")
        .get()
        .then(function (querySnapshot) {
          let docs = [];
          querySnapshot.forEach(function (doc) {
            docs.push(doc.data());
            // doc.data() is never undefined for query doc snapshots

            setTimeout(() => {
              setaccelerator(docs);
            }, 1000);
          });
        });

      Firestore.collection("updates")
        .where("Type", "==", "Crypto Fund")
        .orderBy("createdAt", "desc")
        .get()
        .then(function (querySnapshot) {
          let docs = [];
          querySnapshot.forEach(function (doc) {
            docs.push(doc.data());
            // doc.data() is never undefined for query doc snapshots

            setTimeout(() => {
              setCrypto(docs);
            }, 1000);
          });
        });

      Firestore.collection("updates")
        .where("Type", "==", "Grants")
        .orderBy("createdAt", "desc")
        .get()
        .then(function (querySnapshot) {
          let docs = [];
          querySnapshot.forEach(function (doc) {
            docs.push(doc.data());
            // doc.data() is never undefined for query doc snapshots

            setTimeout(() => {
              setGrant(docs);
            }, 1000);
          });
        });
 
      Firestore.collection("updates")
        .orderBy("createdAt", "desc")

        .get()
        .then(function (querySnapshot) {
          let docs = [];
          querySnapshot.forEach(function (doc) {
            docs.push(doc.data());
            // doc.data() is never undefined for query doc snapshots

            setTimeout(() => {
              setVentureFund(docs);
            }, 1000);
          });
        });

      Firestore.collection("updates")
        .where("Type", "==", "Bounty")
        .orderBy("createdAt", "desc")
        .get()
        .then(function (querySnapshot) {
          let docs = [];
          querySnapshot.forEach(function (doc) {
            docs.push(doc.data());
            // doc.data() is never undefined for query doc snapshots

            setTimeout(() => {
              setBounty(docs);
            }, 1000);
          });
        });

      Firestore.collection("updates")
        .where("Type", "==", "Venture Fund")
        .orderBy("createdAt", "desc")
        .get()
        .then(function (querySnapshot) {
          let docs = [];
          querySnapshot.forEach(function (doc) {
            docs.push(doc.data());
            // doc.data() is never undefined for query doc snapshots

            setTimeout(() => {
              setVentureFund(docs);
            }, 1000);
          });
        });

      Firestore.collection("updates")
        .where("Type", "==", "Hackathon").orderBy("createdAt", "desc")
        .get()
        .then(function (querySnapshot) {
          let docs = [];
          querySnapshot.forEach(function (doc) {
            docs.push(doc.data());
            // doc.data() is never undefined for query doc snapshots

            setTimeout(() => {
              setHackathon(docs);
            }, 1000);
          });
        });
    }

    fetchUpdates();
  }, []);

  const columnsM = [
    {
      title: "Title",
      dataIndex: "Title",
      key: "Title",
    },
    {
      title: "Type",
      dataIndex: "Type",
      key: "Type",
    },
    {
      title: "Funds",
      dataIndex: "Funds",
      key: "Funds",
    },

    {
      title: "Apply",
      key: "Apply ",
      render: (text, record) => (
        <Button
          className="btn-sm mt-2"
          outline
          color="primary"
          onClick={() => window.open(text["Apply "])}
        >
          Apply
        </Button>
      ),
    },
  ];

  const columns = [
    {
      title: "Title",
      dataIndex: "Title",
      key: "Title",
    },
    {
      title: "Type",
      dataIndex: "Type",
      key: "Type",
    },
    {
      title: "Highlight",
      dataIndex: "Highlight",
      key: "Highlight",
    },
    {
      title: "Deadline",
      dataIndex: "Deadline",
      key: "Deadline",
    },
    {
      title: "Funds",
      dataIndex: "Funds",
      key: "Funds",
    },
    {
      title: "Focus_Area",
      dataIndex: "Focus_Area",
      key: "Focus_Area",
    },

    {
      title: "Apply",
      key: "Apply ",
      render: (text, record) => (
        <Button
          className="btn-sm mt-2"
          outline
          color="primary"
          onClick={() => window.open(text["Apply "])}
        >
          Apply
        </Button>
      ),
    },
  ];

  return (
    <UserContext.Consumer>
      {(value) => (
        <>
          <Navigation />
          <Jumbotron className="mb-0">
            <Container>
              <Col lg={12} md={12} sm={12} className="text-center">
                <h1 className="mb-4">
                  <b>
                    Funding Resources &amp; Updates <br /> For Blockchain
                    Developers
                  </b>
                </h1>

                <h3 style={{ lineHeight: 1.4 }}>
                  <b>
                    Find the latest available crypto grants — Get investors for
                    your project <br /> - Get alerts on upcoming events,
                    educational resources and startups
                  </b>{" "}
                </h3>
                <Col md={8} lg={8} className="ml-auto mr-auto pl-0">
                  <Iframe
                    url="https://devangel.substack.com/embed"
                    width="340px"
                    height="100px"
                    id="myId"
                    className="NewsmyClassname"
                    display="initial"
                    position="relative"
                  />
                </Col>
              </Col>

            </Container>
          </Jumbotron>

          <Col
            lg={11}
            className="pt-0 pb-4 ml-auto mr-auto"
            style={{ background: "#f2f2f2" }}
          >
            <Row className="businesses pb-4">
              <Col lg={4} md={4} className="pb-2">
                <Card>
                  <h2 className="text-center">
                    <b>FIND STARTUPS</b>
                  </h2>
                  <hr className="bg-primary" style={{width: '50%'}} />
                  <div className="mb-2 text-left">
                  <h3>Reach out for introductions to blockchain entrepreneurs.</h3>
                  </div>
                  <div className="text-center">
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSe2Xf_laNJ54lJ1ALUk1gbq2eUYFhPYEVeWgYVtOyRnNbHPmw/viewform" target="_blank">
                      <Button outline className="btn-sm" color="warning" size="lg" block>
                      <h2>Connect with Startups</h2>
                      </Button>
                    </a>
                  </div>
                </Card>
              </Col>

              <Col lg={4} md={4} className="pb-2">
                <Card>
                  <h2 className="text-center">
                    <b>NEWS AND UPDATES</b>
                  </h2>
                  <hr className="bg-primary" style={{width: '50%'}} />
                  <div className="mb-2 text-left">
                    <h3>Get the latest updates on upcoming events, hot startups and
                    educational resources.</h3>
                  </div>
                  <div className="text-center">
                    <Link to="/allproduct">
                      <Button outline className="btn-sm" color="info"size="lg" block>
                        <h2>Crypto Hunt</h2>
                      </Button>
                    </Link>
                  </div>
                </Card>
              </Col>

              <Col lg={4} md={4} className="pb-2">
                <Card>
                  <h2 className="text-center">
                    <b>FIND INVESTORS</b>
                  </h2>
                  <hr className="bg-primary" style={{width: '50%'}} />
                  <div className="mb-2 text-left">
                    <h3>Get early feedback from industry experts and investors for
                    your blockchain project.</h3>
                  </div>
                  <div className="text-center">
                    <a className="nav-link" href="https://docs.google.com/forms/d/e/1FAIpQLScIVPmDp3hWkg9d8CW2fw9zQ8Sr8cVE4yQdxh0RhgMPsa5IQw/viewform" target="_blank">
                      <Button outline className="btn-sm" color="primary" size="lg" block>
                      <h2>Connect with Investors</h2>
                      </Button>
                    </a>
                  </div>
                </Card>
              </Col>
            </Row>
          </Col>

          <Col lg={11} className="ml-auto mr-auto seenM">
          <Card className="mb-3 shhowM">
              <CardContent>
                <Tabs defaultActiveKey="1">
                  <TabPane tab={<span>All</span>} key="1">
                    <Table descend  reverse={true} columns={columnsM} dataSource={data.reverse()} />
                  </TabPane>

                  <TabPane tab={<span>Venture Fund</span>} key="2">
                  <Table  reverse={true} columns={columnsM} dataSource={VentureFund.reverse()} />
                  </TabPane>

                  <TabPane tab={<span>Accelerator</span>} key="3">
                         <Table  reverse={true} columns={columnsM} dataSource={accelerator.reverse()} />
                  </TabPane>

                  <TabPane tab={<span>Crypto Fund</span>} key="4">
                    <Table  reverse={true} columns={columnsM} dataSource={Crypto.reverse()} />
                  </TabPane>

                  <TabPane tab={<span>Grants</span>} key="5">
                    <Table  reverse={true} columns={columnsM} dataSource={Grants.reverse()} />
                  </TabPane>

                  <TabPane tab={<span>Bounty</span>} key="6">
                      <Table  reverse={true} columns={columnsM} dataSource={Bounty.reverse()} />
                  </TabPane>

                  <TabPane tab={<span>Hackathon</span>} key="66">
                    <Table  reverse={true} columns={columnsM} dataSource={Hackathon.reverse()} />
                  </TabPane>
                </Tabs>
              </CardContent>
            </Card>
       
            
            <Card className="mb-3 hiddeM">
              <CardContent>
                <Tabs defaultActiveKey="1">
                  <TabPane tab={<span>All</span>} key="1">
                    <Table descend  reverse={true} columns={columns} dataSource={data.reverse()} />
                  </TabPane>

                  <TabPane tab={<span>Venture Fund</span>} key="2">
                  <Table  reverse={true} columns={columns} dataSource={VentureFund.reverse()} />
                  </TabPane>

                  <TabPane tab={<span>Accelerator</span>} key="3">
                         <Table  reverse={true} columns={columns} dataSource={accelerator.reverse()} />
                  </TabPane>

                  <TabPane tab={<span>Crypto Fund</span>} key="4">
                    <Table  reverse={true} columns={columns} dataSource={Crypto.reverse()} />
                  </TabPane>

                  <TabPane tab={<span>Grants</span>} key="5">
                    <Table  reverse={true} columns={columns} dataSource={Grants.reverse()} />
                  </TabPane>

                  <TabPane tab={<span>Bounty</span>} key="6">
                      <Table  reverse={true} columns={columns} dataSource={Bounty.reverse()} />
                  </TabPane>

                  <TabPane tab={<span>Hackathon</span>} key="66">
                    <Table  reverse={true} columns={columns} dataSource={Hackathon.reverse()} />
                  </TabPane>
                </Tabs>
              </CardContent>
            </Card>
          </Col>

          <Footer />
        </>
      )}
    </UserContext.Consumer>
  );
}
